import {
  adminClient,
  inferAdditionalFields,
  phoneNumberClient,
  usernameClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import { ac, admin, superadmin, td, user } from "./permissions";

export const authClient = createAuthClient({
  plugins: [
    phoneNumberClient(),
    usernameClient(),
    adminClient({
      ac,
      roles: {
        superadmin,
        admin,
        td,
        user,
      },
    }),
    inferAdditionalFields({
      user: {
        needsPasswordChange: {
          type: "boolean",
          input: false,
        },
      },
    }),
  ],
});
